import cosmopolitan from './cosmopolitan.webp'
import glamour from './glamour.webp'
import mashable from './mashable.webp'
import mindbodygreen from './mindbodygreen.webp'
import self from './self.webp'
import oprah from './oprah.webp'
import funk from './funk.svg'
import hype from './hype.webp'
import buzzfeed from './buzzfeed.webp'
import telegraph from './telegraph.webp'
import huffpost from './huffpost.webp'
import nyTimes from './ny-times.webp'
import guardian from './guardian.webp'
import metro from './metro.webp'
import businessInsider from './business-insider.webp'
import gruenderszene from './gruenderszene.webp'
import oneLive from './1live.webp'
import separee from './separee.webp'
import blonde from './blonde.webp'
import beziehungsweise from './beziehungsweise.webp'
import nuernbergerNachrichten from './nuernberger-nachrichten.webp'

const brandsEn = [
  {
    name: 'cosmopolitan',
    logo: cosmopolitan
  },
  {
    name: 'glamour',
    logo: glamour
  },
  {
    name: 'telegraph',
    logo: telegraph
  },
  {
    name: 'huffpost',
    logo: huffpost
  },
  {
    name: 'ny-times',
    logo: nyTimes
  },
  {
    name: 'guardian',
    logo: guardian
  },
  {
    name: 'mashable',
    logo: mashable
  },
  {
    name: 'mindbodygreen',
    logo: mindbodygreen
  },
  {
    name: 'self',
    logo: self
  },
  {
    name: 'oprah',
    logo: oprah
  },
  {
    name: 'hype',
    logo: hype
  },
  {
    name: 'buzzfeed',
    logo: buzzfeed
  },
  {
    name: 'metro',
    link: 'https://metro.co.uk',
    logo: metro
  },
  {
    name: 'mashable',
    logo: mashable
  }
]


const brandsDe = [
  {
    name: 'funk',
    logo: funk
  },
  {
    name: 'beziehungsweise',
    logo: beziehungsweise
  },
  {
    name: 'nuernberger-nachrichten',
    logo: nuernbergerNachrichten
  },
  {
    name: 'business-insider',
    logo: businessInsider
  },
  {
    name: 'gruenderszene',
    logo: gruenderszene
  },
  {
    name: '1live',
    logo: oneLive
  },
  {
    name: 'separee',
    logo: separee
  },
  {
    name: 'blonde',
    logo: blonde
  }
]

const brands = {
  en: brandsEn,
  de: brandsDe
}

export default brands

